import React from 'react';
import styled from 'styled-components';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import Upsell from './Upsell';

const ShoppingUpsell: React.FC = () => {
  const { productHeaderData } = useShoppingContext();

  const { upsell_products_title, upsell_products } = productHeaderData;

  const hasUpsellProducts = upsell_products?.length;
  if (!hasUpsellProducts) {
    return null;
  }

  const productCodesOrNull = upsell_products.map((upsellProduct) => upsellProduct?.upsell_product_code);
  const productCodes = productCodesOrNull.filter((code): code is string => code !== null);
  return (
    <Container>
      <Upsell productCodes={productCodes} title={upsell_products_title} />
    </Container>
  );
};

export default ShoppingUpsell;

const Container = styled.div`
  width: 100%;
`;
